// The coffee cup shown on the Duo Cafe order page, used everywhere the cafe appears.
export const DUO_CAFE_LOGO =
  'https://duo-cloud.s3.ap-southeast-2.amazonaws.com/uploads/2026/06/other/2d0a59dc-3fe2-47e6-9d8c-3d8a7236c49d.png'

const CAESAR_LOGO =
  'https://duo-cloud.s3.ap-southeast-2.amazonaws.com/uploads/2026/04/other/9c1cee51-1a86-43aa-b56c-d9c6b6569272.png'

const APP_ICON_BY_NAME: Record<string, string> = {
  caesar: CAESAR_LOGO,
  'duo caesar': CAESAR_LOGO,
  'duo token': 'https://token.duo.tax/favicon.svg',
  'duo cloud': 'https://cloud.duo.tax/cloud.png',
  'duo utility': 'https://utility.duo.tax/favicon.svg',
  'duo trax': 'https://trax.duo.tax/favicon.svg',
  'duo hr': '/duo-hris.svg',
  'duo hris': '/duo-hris.svg',
  'flash mail': 'https://mail.duo.tax/flashmail_logo_orange.png',
  handbook: '/duobooks.svg',
  'duo academy': 'https://academy.duo.tax/academy-logo.svg',
  'security training': '/cyberhoot_logo.png',
  'einstein idea': '/einstein_logo.png',
  'superstar nomination': '/superstar_trophy.png',
  'it ticket': '/ticket.png',
  'duo cafe': DUO_CAFE_LOGO,
}

const APP_ICON_BY_URL: Array<[string, string]> = [
  ['caesar.duo.tax', CAESAR_LOGO],
  ['token.duo.tax', 'https://token.duo.tax/favicon.svg'],
  ['cloud.duo.tax', 'https://cloud.duo.tax/cloud.png'],
  ['utility.duo.tax', 'https://utility.duo.tax/favicon.svg'],
  ['trax.duo.tax', 'https://trax.duo.tax/favicon.svg'],
  ['mail.duo.tax', 'https://mail.duo.tax/flashmail_logo_orange.png'],
  ['academy.duo.tax', 'https://academy.duo.tax/academy-logo.svg'],
  ['docs.duo.tax', 'https://docs.duo.tax/wp-content/uploads/duodocs_favicon-150x150.png'],
]

export const getAppIconOverride = (appName?: string, appUrl?: string) => {
  // HRIS uses the same handshake as its header/favicon. Match the host exactly
  // so old or custom catalogue labels still receive the current app identity.
  try {
    if (appUrl && new URL(appUrl).hostname === 'hr.duo.tax') return '/duo-hris.svg'
  } catch { /* Internal links are handled by the existing mappings below. */ }
  const nameMatch = APP_ICON_BY_NAME[appName?.trim().toLowerCase() || '']
  if (nameMatch) return nameMatch

  const normalizedUrl = appUrl?.toLowerCase() || ''
  return APP_ICON_BY_URL.find(([hostname]) => normalizedUrl.includes(hostname))?.[1]
}
